import { createContext } from 'use-context-selector';
import { type AiAnalystContext } from './types';

const AiAnalystProviderContext = createContext<AiAnalystContext | undefined>(
    undefined,
);

export default AiAnalystProviderContext;

